import { render, staticRenderFns } from "./Kapak.vue?vue&type=template&id=07d5c7e6&"
import script from "./Kapak.vue?vue&type=script&lang=js&"
export * from "./Kapak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports